import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { DomainListItem, DomainsListState } from './types';
import { fetchDomains } from './thunks';

const initialState: DomainsListState = {
  domainList: [],
  selectedDomain: null,
  loading: false,
  error: null,
  hasAttemptedFetch: false,
};

const domainsSlice = createSlice({
  name: 'domains',
  initialState,
  reducers: {
    setDomainList(state, action: PayloadAction<DomainListItem[]>) {
      state.domainList = action.payload;
      state.error = null;
    },
    setSelectedDomain(state, action: PayloadAction<string | null>) {
      state.selectedDomain = action.payload;
    },
    setLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
    setError(state, action: PayloadAction<string | null>) {
      state.error = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDomains.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.hasAttemptedFetch = true;
      })
      .addCase(fetchDomains.fulfilled, (state, action) => {
        state.loading = false;
        state.domainList = action.payload;
      })
      .addCase(fetchDomains.rejected, (state, action) => {
        state.loading = false;
        state.error =
          typeof action.payload === 'string' ? action.payload : 'An unknown error occurred';
      });
  },
});

export const { setDomainList, setSelectedDomain, setLoading, setError } = domainsSlice.actions;
export default domainsSlice.reducer;
